export default function (tns) {
  const container = document.querySelector(
    '.PageMain--great-pet-picks .wp-block-group__inner-container'
  )

  if (!container) {
    return false
  }

  const banners = Array.from(
    document.querySelectorAll('.PromoBannerSlider .blocks-gallery-grid')
  )

  const wpGalleries = Array.from(
    document.querySelectorAll('.PromoBannerSlider.wp-block-gallery')
  )

  wpGalleries.forEach(function (gallery) {
    const blockGallery = gallery.querySelector('.blocks-gallery-grid')

    if (!blockGallery) {
      const div = document.createElement('div')
      div.setAttribute('class', gallery.getAttribute('class'))
      gallery.setAttribute('class', 'blocks-gallery-grid')

      container.insertBefore(div, gallery)
      div.appendChild(gallery)
      banners.push(gallery)
    }
  })

  banners.forEach((slider) =>
    applyTinySlideConfigs(
      slider,
      {
        0: {
          gutter: 0,
          items: 1,
        },
      },
      tns
    )
  )
}

function applyTinySlideConfigs(slider, responsive, tns) {
  removeElementsClasses(slider)

  return tns({
    container: slider,
    gutter: 0,
    nav: true,
    autoHeight: true,
    items: 1,
    edgePadding: 0,
    loop: false,
    preventScrollOnTouch: 'force',
    responsive: responsive,
  })
}

function removeElementsClasses(slider) {
  const items = Array.from(slider.querySelectorAll('figure'))
  return items.map((item) => item.classList.remove('wp-block-image'))
}
